<template>
  <div >
    <div class="content-home">
      <div class="page-wrapper">
        <HomeMenu></HomeMenu>
        <v-main>
          <router-view/>
        </v-main>
        <HomeFooter></HomeFooter>
      </div>
    </div>
  </div>
</template>

<script>
    import HomeMenu from "./HomeMenu";
    import HomeFooter from "./HomeFooter";
    export default {
        data: function() {
            return {

            }
        },
        name: 'Home',
        methods:{

        },
        created(){
        },
        destroyed () {

        },
        computed: {

        },
        components: {
          HomeFooter,
          HomeMenu
        }
    }


</script>

<style scoped>

</style>